import { useCallback } from 'react';
import TagManager from 'react-gtm-module';

declare global {
  interface Window {
    gtag?: (command: 'event', eventName: string, params: Record<string, unknown>) => void;
  }
}

// Plain-function form of the gtag seam, for callers outside React (e.g. the
// product quantity store's cart events).
export const sendGoogleAnalyticsGTagEvent = (eventCategory: string, params: Record<string, unknown>) => {
  window.gtag?.('event', eventCategory, params);
};

const useGoogleAnalytics = () => {
  const sendGoogleAnalyticsEvent = useCallback((eventCategory: string, params: Record<string, unknown>) => {
    TagManager.dataLayer({
      dataLayer: {
        eventCategory,
        ...params,
      },
    });
  }, []);

  return { sendGoogleAnalyticsEvent, sendGoogleAnalyticsGTagEvent };
};

export default useGoogleAnalytics;
